import React from 'react';

const ErrorFallback = () => (
    <div style={{ padding: "20px", textAlign: "center" }}>
        <h1>Something went wrong.</h1>
        <p>Our team has been notified. Please try refreshing the page.</p>
    </div>
);

export default ErrorFallback;
